<template>
  <div class="trCmp full-height linear-main3">
    <ld-header
      @click-left="$router.push({ path: '/home' })"
      transparent
      white
    >
      {{ $t('A127','预订完成') }}
    </ld-header>

    <van-pull-refresh
      class="wrapper"
      v-model="isLoading"
      @refresh="getDetail"
    >
      <div class="white pad8">
        <van-row class="font-lg font24 mt5">
          <ld-icon
            :type="detail.isShowSs == 1 ? 'iconshenpi1' :
              detail.isShowPay == 1 ? 'iconzhifu' :
              detail.isReject ? 'iconquxiao' :
              'icondingzuoshj-icon-Reser'"
            size="30"
            class="order-status__icon"
          />
          {{ detail.orderStatusDesc }}
        </van-row>
        <van-row
          class="font12 mt5"
        >
          {{ detail.orderStatusDescDetail }}
        </van-row>
      </div>

      <div
        class="pad8"
        v-if="detail.orderNo"
      >
        <van-row class="round-sm pad8 van-row bg-white">
          {{ $t('F001','订单号') }}：{{ detail.orderNo }}

          <router-link
            class="main-color fr"
            :to="`/tr/OrderDetail/${id}`"
          >
            {{ $t('B011','查看订单') }}
          </router-link>
        </van-row>

        <!-- 经停信息 -->
        <div class="round-sm mt5">
          <stop-station
            class="bg-white van-hairline--bottom"
            :detail="detail"
            train-no-class="main-color"
          />
        </div>

        <!-- 乘车人列表 -->
        <van-cell-group class="mt5 round-sm">
          <psg-panel
            v-for="(passenger, i) in detail.psgList"
            :key="i"
            :passenger="passenger"
          />
        </van-cell-group>

        <ld-button
          class="mt5"
          detault
          to="/tr/trQuery"
        >
          {{ $t('B012','继续预订') }}
        </ld-button>
      </div>

      <van-row
        v-if="detail.isShowSs == 1"
        class="pad8 orange bg-lightYellow"
      >
        {{ $t('Warm','温馨提示：系统支持“多个行程合并送审”功能，您可以“继续预订”完其他行程后，再操作“送审”') }}。
      </van-row>

      <!--      <van-row
        v-if="detail.isShowPay == 1"
        class="pad8 orange bg-lightYellow"
      >
        {{ $t('I070','温馨提示：服务商不提供报销凭证，请乘客自行到车站换取。') }}
      </van-row>-->
    </van-pull-refresh>


    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        justify="space-between"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          offset="1"
          span="11"
        >
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ detail.totalAmount }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}{{ detail.psgList && detail.psgList.length }}人</span>

          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          span="12"
          class="pad5 text-right"
        >
          <ld-button
            main
            size="md"
            v-if="detail.isShowSs == 1"
            @click.stop="btnClick('approval')"
          >
            {{ $t('B028','送审') }}
          </ld-button>

          <ld-button
            main
            size="md"
            v-else-if="detail.isShowPay == 1"
            @click.stop="pay"
          >
            {{ $t('B014','支付') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      :order-type="detail.orderType"
      :order-id="id"
    /> -->
  </div>
</template>

<script>
import { CellGroup, Cell, PullRefresh } from 'vant'
import { mapState } from 'vuex'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import StopStation from '../trQuery/StopStation'
// import ldPay from 'Components/ldPay/index.vue'
import PsgPanel from './PsgPanel'
import handle from './handle'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'

export default {
  name: 'TrCmp',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    ldButton,
    ldTabbar,
    StopStation,
    PsgPanel,
    // ldPay
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      detail: {}, // 正常单详情
      time: 5,
      timer: null
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.isLoading = true

      const { data } = await TrainOrderInteractor.getDetailById(this.id)

      this.isLoading = false
      this.detail = data

      if (this.detail.isLoop && !this.timer) this.loop()
      if (!this.detail.isLoop && this.timer) clearInterval(this.timer)
    },
    async btnClick (handleType) {
      // 是否二次送审 登录人 bookStyle 是单订模式 1，还是出差申请单模式  2
      var bookStyle = this.vipCorp.bookStyle
      if (bookStyle == 2) {
        this.detail.againApp = 1
      } else {
        this.detail.againApp = 0
      }

      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    },
    pay() {
      // this.$refs.pay.toggle()
      this.$router.push({path:'/pay/payment',query:{orderType:this.detail.orderType,orderId:this.id}})
    },
    // 重复查询
    loop() {
      this.timer = setInterval(() => {
        this.time--
        if(this.time < 0) {
          this.time = 5
          this.getDetail()
        }
      }, 1000)
    }
  },
  computed: {
    priceList () {
      let rt = []
      if (this.detail.psgList) {
        let psgList = this.detail.psgList,
          adult = psgList.find(psg => psg.passengerType === '1'),
          child = psgList.find(psg => psg.passengerType === '2')


        rt = [
          { name: '总额', price: this.detail.totalAmount }
        ]
        if (adult) rt.push({ name: adult.passengerTypeName, price: adult.ticketPrice, amount: this.detail.adultCount, unit: '人' })
        if (child) rt.push({ name: child.passengerTypeName, price: child.ticketPrice, amount: this.detail.childCount, unit: '人' })
        if (this.detail.bxPrice) rt.push({ name: '保险', price: this.detail.bxPrice / psgList.length, amount: psgList.length, unit: '人' })
        rt.push({ name: '服务费', price: this.detail.sellServiceCharge / psgList.length, amount: psgList.length, unit: '人' })
      }
      return rt
    },
    ...mapState({
      vipCorp: state => state.app.userInfo.vipCorp
    })
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="less">
.trCmp {

  .wrapper {
    height: calc(100vh - 96px);
  }

  p {
    margin: 0;
  }

  .pad5 {
    padding: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .round-sm {
    overflow: hidden;
  }

  .order-status__icon {
    vertical-align: middle;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }
}
</style>

